<script>
    import { CircleSpinner } from "@axel669/zephyr"
</script>

<CircleSpinner ws="@size: 80px;" />
<CircleSpinner ws="@color: @success;" />
<CircleSpinner ws="@size: 120px; @color: @accent;" />
<CircleSpinner ws="@size: 140px; @color: @warning;" />
<CircleSpinner ws="@size: 160px; @color: @error;" />
